const STORAGE_KEY = 'sommer2026_submittedAt';
const COOLDOWN_MS = 24 * 60 * 60 * 1000; // 1 day
// const COOLDOWN_MS = 15 * 1000; // 15 seconds

function isWithinCooldown() {
   const submittedAt = localStorage.getItem(STORAGE_KEY);
   if (!submittedAt) return false;
   return Date.now() - parseInt(submittedAt, 10) < COOLDOWN_MS;
}

function markSubmitted() {
   localStorage.setItem(STORAGE_KEY, Date.now().toString());
}

const register = {
   form: document.getElementById('register-form'),
   name: document.getElementById('register-name'),
   phone: document.getElementById('register-phone'),
   address: document.getElementById('register-address'),
   size: document.getElementById('register-size'),
   answer: document.getElementById('register-answer'),
   submit: document.getElementById('register-submit'),
};

const submit = {
   container: document.querySelector('.submit-message'),
   success: document.getElementById('submit-success'),
   error: document.getElementById('submit-error'),
}

function showMessage() {
   submit.container.classList.remove('hidden');
   submit.container.classList.add('animate-in');
   requestAnimationFrame(() => {
      requestAnimationFrame(() => {
         submit.container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
   });
}

// wait for HTML to load
document.addEventListener('DOMContentLoaded', () => {
   // hide form immediately if within cooldown from a previous submission
   if (isWithinCooldown()) {
      register.form.classList.add('hidden');
      submit.container.classList.remove('hidden');
      submit.success.classList.remove('hidden');
   }

   // limit textarea to 6 rows
   const textarea = register.answer;
   const maxLines = 6;
   if (textarea) {
      textarea.addEventListener('keydown', function(event) {
         const lines = textarea.value.split('\n').length;

         if (event.key === 'Enter' && lines >= maxLines)
            event.preventDefault();
      });
   }

   // form
   if (register.submit) {
      register.submit.addEventListener('click', (event) => {
         // HTML validation
         if (register.form.checkValidity()) {
            event.preventDefault();

            if (isWithinCooldown()) {
               return;
            }

            const bodyParams = new URLSearchParams({
               table: 'Sommer2026',
               campaign: 'Sommerkampanje',
               name: register.name.value,
               phone: register.phone.value,
               address: register.address.value,
               size: register.size.value,
            });

            fetch('/_/service/no.tine.tine/entrySave', {
               method: 'POST',
               headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
               body: bodyParams,
            })
            .then((response) => {
               if (response.status.toString().startsWith('2')) {
                  // success
                  markSubmitted();
                  submit.success.classList.remove('hidden');
                  submit.error.classList.add('hidden');
                  register.form.classList.add('hidden');
               } else {
                  // error
                  submit.success.classList.add('hidden');
                  submit.error.classList.remove('hidden');

                  console.error('-------- error --------');
                  console.error(response);
               }

               showMessage();
            })
            .catch((error) => {
               console.error('-------- error --------');
               console.error(error);

               submit.error.classList.remove('hidden');
               register.form.classList.add('hidden');
               submit.success.classList.add('hidden');
               showMessage();
            });
         }
      });
   } else {
      console.info('No submit button defined');
   }
});
